module.exports = __webpack_public_path__ + "Roboto-Medium.4d9f3f9e5195e7b074bb.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Medium.eot
// module id = 87
// module chunks = 2